<template>
  <main>
    <div id="challengeContainer" data-test="3ds-challenge" class="container" />
  </main>
</template>

<script>
import { AuthenticationStrategy } from '@mc-alberta/stark'
import { defineComponent, getCurrentInstance, onMounted } from '@vue/composition-api'
import { LOADERS, ROUTES } from '@/constants'
import { getStark, sessionRouteGuard } from '@/store/modules/authentication'

export default defineComponent({
  name: ROUTES.VERIFY_ISSUER_CHALLENGE,
  beforeRouteEnter(to, from, next) {
    return sessionRouteGuard(AuthenticationStrategy.THREE_DS, next)
  },
  setup() {
    onMounted(async () => {
      const { proxy } = getCurrentInstance()
      const store = proxy.$store
      const stark = getStark()

      store.dispatch('stopAllLoaders')
      await stark.provideChallenge('#challengeContainer')
      store.dispatch('startLoader', LOADERS.VERIFY_DETAILS)
      store.dispatch('handleAuthSession', await stark.validateSession())
    })
  }
})
</script>
